import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { CLIENT_GSERVICE_URL } from 'src/constants';

const WidgetGoldStat = () => {
  const [dataGold, setDataGold] = useState(null);

  const fetchData = async () => {
    const res = await fetch(`${CLIENT_GSERVICE_URL}/gold`);
    const resJson = await res.json();
    setDataGold(resJson);
  };

  useEffect(() => {
    fetchData();
  }, []);

  let dataUpdate = null;
  if (dataGold !== null) {
    dataUpdate = dayjs(dataGold?.datetime).locale('th').format('DD MMM BBBB เวลา H:mm น.');
  }

  return (
    <div className='widget-gold-stat'>
      {dataGold !== null && (
        <>
          <h2>ราคาทองคำ</h2>
          <div className='widget-gold-stat-box'>
            <ul>
              <li>95.5%</li>
              <li>รับซื้อ (บาท)</li>
              <li>ขายออก (บาท)</li>
            </ul>
            <ul>
              <li>ทองคำแท่ง</li>
              <li>{dataGold?.lblBLBuy}</li>
              <li>{dataGold?.lblBLSell}</li>
            </ul>
            <ul>
              <li>ทองรูปพรรณ</li>
              <li>{dataGold?.lblOMBuy}</li>
              <li>{dataGold?.lblOMSell}</li>
            </ul>
          </div>
          <p className='date-update'>อัพเดท {dataUpdate}</p>
        </>
      )}
    </div>
  );
};

export default WidgetGoldStat;
